export const display_mockup_modal_reducer = (state=false, action) => {
	switch (action.type) {
		case "SHOW_UPLOAD_IMAGE_MODAL":
	  		return true;
  		case "HIDE_UPLOAD_IMAGE_MODAL":
	  		return false;
		default:
	  		return false;
    }
};

